export default __webpack_public_path__ + "static/media/insightslogo.b7dc2771.svg";